import React, { useEffect, useState } from "react";

import "../AssessmentHistory/AssessmentHistory.css";
import "../../Components/Commons/Commons.css";
import "quill/dist/quill.snow.css";
import "chart.js/auto";

import AntDTable from "../AntDTable/AntDTable";
import BtnSave from "../Commons/Buttons/BtnSave";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Button, Card, Radio, Tag } from "antd";
import { Col, Row } from "react-bootstrap";
import {
  getAssessmentHistory,
  printEkas,
  printEpress,
} from "../Helpers/API/AssessmentApi/AssessmentApi";
import { formatDate } from "../../Assets/Helpers/Common";
import { RefreshRounded } from "@mui/icons-material";
import {
  capitalizeText,
  formatDateWithTime,
  formatDateYYYYMMDD,
} from "../Helpers/Utilities/Common";
import BtnClearDropdown from "../Commons/Buttons/BtnClearDropdown";
import TextArea from "../Commons/Forms/TextArea";
import TextField from "../Commons/Forms/NumberInput";
import NumberInput from "../Commons/Forms/NumberInput";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import { getVitalSigns } from "../Helpers/API/VitalSignsApi/VitalSignsApi";

function HealthScreening({ patientId }) {
  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [isClicked, setIsClicked] = useState(false);

  //Function for Action button will be added in the table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center px-1">
          <Col className="m-0 p-0">
            <BtnSave
              id={"view-btn"}
              label={"View"}
              size={"sm"}
              onClick={(e) => {
                setIsClicked(true);
                setSelectedRow(row.row);
              }}
            />
          </Col>
        </Row>
      </>
    );
  }

  async function _fetchAssessmentHistory() {
    setShowLoader(true);
    const [resAssessments, resVitals] = await Promise.all([
      getAssessmentHistory({ patient_id: patientId }),
      getVitalSigns(patientId),
    ]);

    const assessments = resAssessments?.data?.data || [];
    const vitals = resVitals?.data?.data || [];

    const mappedAssessments = assessments.map((assessment) => {
      const hs = assessment?.health_screening || {};
      return {
        ...assessment,
        source: "assessment",
        assessment_date:
          assessment.is_sunday_patient === "1"
            ? formatDate(assessment.last_checkup_date)
            : formatDate(assessment.added_on),
        raw_assessment_date:
          assessment.is_sunday_patient === "1"
            ? assessment.last_checkup_date
            : assessment.added_on,
        fomattedAddedOn: formatDateWithTime(assessment.added_on),
        chief_complaint: hs?.chief_complaint || "",
        has_complaint_2: hs?.complaint_2 ? "1" : "0",
        complaint_2: hs?.complaint_2 || "",
        has_complaint_3: hs?.complaint_3 ? "1" : "0",
        complaint_3: hs?.complaint_3 || "",
        has_complaint_4: hs?.complaint_4 ? "1" : "0",
        complaint_4: hs?.complaint_4 || "",
        has_complaint_5: hs?.complaint_5 ? "1" : "0",
        complaint_5: hs?.complaint_5 || "",
        has_complaint_6: hs?.complaint_6 ? "1" : "0",
        complaint_6: hs?.complaint_6 || "",
        last_mens_period: hs?.last_mens_period || "",
        first_mens_period: hs?.first_mens_period || "",
        has_complaint_8: hs?.complaint_8 ? "1" : "0",
        complaint_8: hs?.complaint_8 || "",
      };
    });

    const mappedVitals = vitals.map((vs) => {
      return {
        ...vs,
        source: "vital",
        assessment_date: formatDate(vs.added_on),
        raw_assessment_date: vs.added_on,
        fomattedAddedOn: formatDateWithTime(vs.added_on),
        chief_complaint: vs?.chief_complaint || vs?.complaint || "",
        has_complaint_2: vs?.complaint_2 ? "1" : "0",
        complaint_2: vs?.complaint_2 || "",
        has_complaint_3: vs?.complaint_3 ? "1" : "0",
        complaint_3: vs?.complaint_3 || "",
        has_complaint_4: vs?.complaint_4 ? "1" : "0",
        complaint_4: vs?.complaint_4 || "",
        has_complaint_5: vs?.complaint_5 ? "1" : "0",
        complaint_5: vs?.complaint_5 || "",
        has_complaint_6: vs?.complaint_6 ? "1" : "0",
        complaint_6: vs?.complaint_6 || "",
        last_mens_period: vs?.last_mens_period || "",
        first_mens_period: vs?.first_mens_period || "",
        has_complaint_8: vs?.complaint_8 ? "1" : "0",
        complaint_8: vs?.complaint_8 || "",
      };
    });

    const combined = [...mappedAssessments, ...mappedVitals].sort((a, b) => {
      const ad = new Date(a.raw_assessment_date || 0).getTime();
      const bd = new Date(b.raw_assessment_date || 0).getTime();
      return bd - ad;
    });

    setData(combined);
    setShowLoader(false);
  }

  useEffect(() => {
    _fetchAssessmentHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  return (
    <Card className="card-with-table">
      <div className="row">
        <Row className="align-items-center pb-4 px-4">
          <Col xs={"auto"} className="p-0 align-items-center">
            <h5 className="font-bold">HEALTH SCREENING HISTORY</h5>
          </Col>
          <Col xs={"auto"} className="px-2 pb-2">
            <Button
              type="text"
              onClick={_fetchAssessmentHistory}
              icon={<RefreshRounded />}
            />
          </Col>
        </Row>

        <AntDTable
          tableHeaders={["DATE", "CHIEF COMPLAINT"]}
          headerSelector={["assessment_date", "chief_complaint"]}
          tableData={data}
          loading={showLoader}
          scroll={{ x: true }}
          isClickable={false}
          withAction={true}
          ActionBtn={(row) => ActionBtn(row)}
        />

        {selectedRow?.length !== 0 && isClicked && (
          <>
            <div className="px-3">
              <Row className="bg-white p-3 rounded-3">
                <Row className="align-items-center pb-4 px-4">
                  <Col xs={"auto"} className="p-0 align-items-center">
                    <h5 className="font-bold">HEALTH SCREENING FORM</h5>
                  </Col>
                </Row>
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">1.</span>
                    <p className="question-text">Chief complaint</p>
                  </div>
                </Col>
                <Col xs={12} className="ps-5">
                  <TextArea
                    id="chief_complaint"
                    name="chief_complaint"
                    value={selectedRow?.chief_complaint}
                    disabled={true}
                  />
                </Col>
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">2.</span>
                    <p className="question-text">
                      Do you experience any of the following: loss of appetite,
                      lack of sleep, unexplained weight loss, feeling
                      down/depressed, fever, headache, memory loss, blurring of
                      vision, or hearing loss?
                    </p>
                  </div>
                </Col>
                <Col className="form-label align-left mt-2 ps-5">
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_2"
                    value={selectedRow?.has_complaint_2}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </Col>
                {selectedRow?.has_complaint_2 === "1" && (
                  <>
                    <Col xs={12} className="ps-5">
                      <TextArea
                        id="complaint_2"
                        name="complaint_2"
                        formLabel={`If yes, please explain:`}
                        value={selectedRow?.complaint_2}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">3.</span>
                    <p className="question-text">
                      Do you experience any of the following: cough/colds, chest
                      pain, palpitations, or difficulty in breathing?
                    </p>
                  </div>
                </Col>
                <Col className="form-label align-left mt-2 ps-5">
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_3"
                    value={selectedRow?.has_complaint_3}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </Col>
                {selectedRow?.has_complaint_3 === "1" && (
                  <>
                    <Col xs={12} className="ps-5">
                      <TextArea
                        id="complaint_3"
                        name="complaint_3"
                        formLabel={`If yes, please explain:`}
                        value={selectedRow?.complaint_3}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">4.</span>
                    <p className="question-text">
                      Do you experience any of the following: abdominal pain,
                      vomiting, change in bowel movement, rectal bleeding, or
                      bloody/tarry stools?
                    </p>
                  </div>
                </Col>
                <Col className="form-label align-left mt-2 ps-5">
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_4"
                    value={selectedRow?.has_complaint_4}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </Col>
                {selectedRow?.has_complaint_4 === "1" && (
                  <>
                    <Col xs={12} className="ps-5 mt-2">
                      <TextArea
                        id="complaint_4"
                        name="complaint_4"
                        formLabel={`If yes, please explain:`}
                        value={selectedRow?.complaint_4}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">5.</span>
                    <p className="question-text">
                      Do you experience any of the following: frequent
                      urination, frequent eating, frequent intake of fluids?
                    </p>
                  </div>
                </Col>
                <Col className="form-label align-left mt-2 ps-5">
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_5"
                    value={selectedRow?.has_complaint_5}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </Col>
                {selectedRow?.has_complaint_5 === "1" && (
                  <>
                    <Col xs={12} className="ps-5">
                      <TextArea
                        id="complaint_5"
                        name="complaint_5"
                        formLabel={`If yes, please explain:`}
                        value={selectedRow?.complaint_5}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                <Col xs={12}>
                  <div className="question-label">
                    <span className="question-number">6.</span>
                    <p className="question-text">
                      For male and female, do you experience any of the
                      following: pain or discomfort on urination, frequency of
                      urination, dribbling of urine, pain during/after sex,
                      blood in urine, or foul-smelling genital discharge?
                    </p>
                  </div>
                </Col>
                <Col className="form-label align-left mt-2 ps-5">
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_6"
                    value={selectedRow?.has_complaint_6}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </Col>
                {selectedRow?.has_complaint_6 === "1" && (
                  <>
                    <Col xs={12} className="ps-5 mt-2">
                      <TextArea
                        id="complaint_6"
                        name="complaint_6"
                        formLabel={`If yes, please explain:`}
                        value={selectedRow?.complaint_6}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                {selectedRow?.patient_sex === "FEMALE" && (
                  <>
                    <Col xs={12}>
                      <div className="question-label">
                        <span className="question-number">7.</span>
                        <p className="question-text">For females only,</p>
                      </div>
                    </Col>
                    <Row className="ps-5">
                      <Col className="question-text mt-2">
                        <TextField
                          id="last_mens_period"
                          name="last_mens_period"
                          formLabel={`a. Last menstrual period`}
                          size={`sm`}
                          disabled={true}
                        />
                      </Col>
                      <Col className="question-text mt-2">
                        <TextField
                          id="first_mens_period"
                          name="first_mens_period"
                          formLabel={`b. First menstrual period`}
                          size={`sm`}
                          disabled={true}
                        />
                      </Col>
                      <Col className="question-text mt-2">
                        <NumberInput
                          id="preg_count"
                          name="preg_count"
                          formLabel={`Number of pregnancy`}
                          size={`sm`}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Col xs={12}>
                      <div className="question-label">
                        <span className="question-number">8.</span>
                        <p className="question-text">
                          Do you experience any of the following: muscle spasm,
                          tremors, weakness; muscle/joint pain stiffness,
                          limitation of movement?,
                        </p>
                      </div>
                    </Col>
                    <Col className="form-label align-left mt-2 ps-5">
                      <Radio.Group
                        className="w-full mt-2"
                        name="has_complaint_8"
                        value={selectedRow?.has_complaint_8}
                      >
                        <Radio value="1">Yes</Radio>
                        <Radio value="0">No</Radio>
                      </Radio.Group>
                    </Col>
                    {selectedRow?.has_complaint_8 === "1" && (
                      <>
                        <Col xs={12} className="ps-5 mt-2">
                          <TextArea
                            id="complaint_8"
                            name="complaint_6"
                            formLabel={`If yes, please explain:`}
                            value={selectedRow?.complaint_8}
                            disabled={true}
                          />
                        </Col>
                      </>
                    )}
                    <Row className="d-flex justify-content-end px-1 mt-3">
                      <Col xs={3} className="m-0 p-0">
                        <BtnDelete
                          label={"Close"}
                          size={"sm"}
                          onClick={(e) => {
                            setIsClicked(false);
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Row>
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
export default HealthScreening;
